import { format } from "date-fns";
import React from "react";
import { useAppSelector } from "../../../lib/redux/hook.ts";
import { AppointmentsDTO } from "./dto.ts";

interface Props {
    appointment: AppointmentsDTO;
    onClick: () => void
}
export function DetailedListAppointment(props: Props) {
    const { appointment } = props;

    const layoutState = useAppSelector(state => state.layout);
    const companyState = useAppSelector(state => state.company)

    const company = companyState.findAllCompanyResponse?.data.find(item => item.id === appointment.companyId)
    let companyName: string = ''

    if(company) companyName = company.companyName.trim()? company.companyName : (company.name + " " + company.surname)

    return (
        <div onClick={() => props.onClick && props.onClick()} className=" cursor-pointer flex flex-col gap-1">
            <div className="flex w-full h-auto gap-2 items-center">
                <span className="text-nowrap w-9 text-text-sm font-bold text-neutral-800">{format(appointment.startDate!, "HH:mm")}</span>
                <div className="h-6 w-1 block rounded-md" style={{ backgroundColor: layoutState.theme[300] }} />
                <span className="text-text-md font-semibold text-neutral-800">{"[" + companyName + "] " + (appointment.title.length <10? appointment.title : appointment.title.substring(0,8).concat('...'))}</span>
            </div>
            <div className="flex">
                <span className="pl-14 text-nowrap crop-text text-text-xs text-neutral-700">{format(appointment.startDate!, "HH:mm")} - {format(appointment.endDate!, "HH:mm")} {appointment.notes && ' | ' + appointment.notes}</span>
            </div>
        </div>
    )
}